import { useMsal } from "@azure/msal-react";
import { beginInteractiveLogin } from "../auth/acquireIdToken";

/**
 * Getoond als stil vernieuwen niet lukte en de automatische gang naar Microsoft
 * ook niets opleverde. Geen tweede stille poging: die veroorzaakte een reload-lus.
 */
export default function SessionExpiredPage() {
  const { accounts } = useMsal();
  const hasAccount = accounts.length > 0;

  return (
    <div className="page" style={{ maxWidth: 32 * 16, margin: "2rem auto" }}>
      <h1 className="page-title" style={{ marginTop: 0 }}>
        Aanmelden vereist
      </h1>
      <p className="page-subtitle">
        {hasAccount
          ? "Je Microsoft-sessie is verlopen. Je wordt normaal automatisch doorgestuurd. Lukt dat niet, meld dan hier opnieuw aan."
          : "De verbinding met de app-server is verlopen. Meld opnieuw aan met Microsoft om verder te gaan."}
      </p>
      <p style={{ marginTop: "1.5rem" }}>
        <button
          type="button"
          className="btn-primary"
          onClick={() => {
            void beginInteractiveLogin({ force: true });
          }}
        >
          Opnieuw aanmelden met Microsoft
        </button>
      </p>
    </div>
  );
}
